import {
  blue,
  grey,
  red,
  brown,
  lime,
  lightGreen,
  green,
  orange,
  yellow
} from '@material-ui/core/colors'

// export const wetlandMetadata = [
//   {
//     key: 'Class',
//     value: 0,
//     label: 'Bog',
//     color: lime[900]
//   },
//   {
//     key: 'Class',
//     value: 1,
//     label: 'Fen',
//     color: lightGreen[500]
//   },
//   {
//     key: 'Class',
//     value: 2,
//     label: 'Grassland',
//     color: green[500]
//   },
//   {
//     key: 'Class',
//     value: 3,
//     label: 'Forest',
//     color: green[500]
//   },
//   {
//     key: 'Class',
//     value: 4,
//     label: 'Shallow water',
//     color: blue[500]
//   },
//   {
//     key: 'Class',
//     value: 5,
//     label: 'Urban / Bare land',
//     color: grey[400]
//   },
//   {
//     key: 'Class',
//     value: 6,
//     label: 'Deep water',
//     color: blue[900]
//   },
//   {
//     key: 'Class',
//     value: 7,
//     label: 'Upland',
//     color: lightGreen['900']
//   },
// ]

export const wetlandMetadata = [
  {
    key: 'Class',
    value: 0,
    label: 'Bog',
    color: 'rgb(168, 168, 0)'
  },
  {
    key: 'Class',
    value: 1,
    label: 'Fen',
    color: 'rgb(152, 230, 0)'
  },
  {
    key: 'Class',
    value: 2,
    label: 'Marsh',
    color: 'rgb(255, 255, 0)'
  },
  {
    key: 'Class',
    value: 3,
    label: 'Swamp',
    color: 'rgb(255, 170, 0)'
  },
  {
    key: 'Class',
    value: 4,
    label: 'Shallow water',
    color:'rgb(0, 197, 255)'
  },
  {
    key: 'Class',
    value: 5,
    label: 'Urban / Bare land',
    color: 'rgb(156, 156, 156)'
  },
  {
    key: 'Class',
    value: 6,
    label: 'Deep water',
    color: 'rgb(0, 92, 230)'
  },
  {
    key: 'Class',
    value: 7,
    label: 'Upland',
    color: 'rgb(56, 168, 0)'
  },
]



// WEBPACK FOOTER //
// ./src/config/wetland.js